import { environment } from '../../environments/environment';

export class APIBackUrl{
    public static API_CONTEXT_PATH = 'api'
    public static API_BASE_PATH = environment.backUrl + APIBackUrl.API_CONTEXT_PATH

    public static LIST_LOCATION = `${APIBackUrl.API_BASE_PATH}/location/list`
    public static LIST_COMPANY_BY_TYPE = `${APIBackUrl.API_BASE_PATH}/company`
    public static SAVE_REQUEST_FORM = `${APIBackUrl.API_BASE_PATH}/requestForm/save`
    public static LIST_REQUEST_FORM = `${APIBackUrl.API_BASE_PATH}/requestForm/list`
    public static GET_REQUEST_FORM = `${APIBackUrl.API_BASE_PATH}/requestForm`
    public static SAVE_COMMENT = `${APIBackUrl.API_BASE_PATH}/requestForm/saveComment`
    public static DO_ACTION_REQUEST_FORM = `${APIBackUrl.API_BASE_PATH}/requestForm`

    public static DOWNLOAD_ATTACHMENT = `${APIBackUrl.API_BASE_PATH}/attachment`

    public static LIST_PERSON_HISTORY = `${APIBackUrl.API_BASE_PATH}/personHistory/list`
    public static LIST_PERSON_HISTORY_BY_COMPANY = `${APIBackUrl.API_BASE_PATH}/personHistory/listByCompany/`
}



// WEBPACK FOOTER //
// /app/src/app/shared/api-back-url.ts